import React, { Dispatch, SetStateAction } from 'react';
import { AvButton } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

interface SelectAllRowsButtonProps {
  width?: number;
  colspan: number;
  totalRows: number;
  currentPageRows: number;
  onClearSelection: () => void;
  onSelectAllRows: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  isClickedAll: boolean;
  setAllClicked: Dispatch<SetStateAction<boolean>>;
}

export const SelectAllRowsButton: React.FC<SelectAllRowsButtonProps> = ({
  colspan,
  totalRows,
  currentPageRows,
  onClearSelection,
  onSelectAllRows,
  width,
  isClickedAll,
  setAllClicked,
}) => (
  <TableRow>
    <TableCell colSpan={colspan} align="center" sx={{ background: theme => theme.palette.colors.neutrals[300] }}>
      <Box sx={{ ...flex.center, gap: 1, width }}>
        {!isClickedAll ? (
          <>
            You selected all {currentPageRows} rows on this page.{' '}
            <AvButton
              size="xSmall"
              sx={{
                height: '100%',
                py: 0,
                color: theme => theme.palette.primary.main,
              }}
              onClick={e => {
                onSelectAllRows(e);
                setAllClicked(true);
              }}>
              {' '}
              Select all {totalRows.toLocaleString()} rows
            </AvButton>
          </>
        ) : (
          <>
            You selected all {totalRows}{' '}
            <AvButton size="xSmall" sx={{ color: theme => theme.palette.primary.main }} onClick={onClearSelection}>
              Clear Selection
            </AvButton>
          </>
        )}
      </Box>
    </TableCell>
  </TableRow>
);
